export default async function ({ store, redirect, params }) {
  if (!store.getters["user/IS_BAND"]) return redirect("/")
}
